import EmployeeLayout from '@/layouts/EmployeeLayout.vue';

export default [
  {
    path: '/',
    name: 'index',
    component: EmployeeLayout,
    redirect: {
      name: 'home',
    },
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('../views/employee/debts'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/stats',
        name: 'stats',
        component: () => import('../views/employee/stats.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/rating',
        name: 'rating',
        component: () => import('../views/employee/rating.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/payments',
        name: 'payments',
        component: () => import('../views/employee/payments.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/debt/:id',
        name: 'debt-detail',
        component: () => import('../views/employee/debts/detail'),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      layout: 'empty',
    },
    component: () => import('../views/auth/Login.vue'),
  },

];
